export default __webpack_public_path__ + "static/media/Fail-Dark.2cc4fd12.svg";